import { z } from 'zod';

export const AuditAssignmentSchema = z.object({
    id: z.string().optional(),
    assessmentId: z.string().min(1),
    auditorId: z.string().min(1),
    role: z.enum(['lead', 'member', 'observer']),
    status: z.string().default('assigned'),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAuditAssignmentSchema = AuditAssignmentSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateAuditAssignmentSchema = AuditAssignmentSchema.partial();
